module.exports = __webpack_public_path__ + "static/media/news-item-frame-9-slice.36211878.png";